import React, { useLayoutEffect, useRef } from 'react';
import * as StatsActions from '../../actions/StatsActions'

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_dark from "@amcharts/amcharts4/themes/dark";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_dark);
am4core.useTheme(am4themes_animated);

export interface IHorizontalDumbellPlotChartDataItem {
    category: string;
    openValue: number;
    closeValue: number;
    difference: number;
    extraData1: string;
    extraData2: string;
  }

export interface IHorizontalDumbellPlotChartProps {
    id: string;
    data: Array<IHorizontalDumbellPlotChartDataItem>
    tooltipText: string;
  }

const HorizontalDumbellPlotChart: React.FC<IHorizontalDumbellPlotChartProps> = (props: IHorizontalDumbellPlotChartProps) => {
    const chart = useRef();

    useLayoutEffect(() => {
        let c = am4core.create(`${props.id}`, am4charts.XYChart);

        let data = [];
        let open = 100;
        let close = 120;

        if (props.data) {
            for (var i = 0; i < props.data.length; i++) {
                let item = props.data[i];
                data.push({
                    category: item.category,
                    openValue: item.openValue,
                    closeValue: item.closeValue,
                    difference: item.difference,
                    extraData1: item.extraData1,
                    extraData2: item.extraData2,
                });
            }
        }

        c.data = data;
        //c.numberFormatter.numberFormat = "00.00'%'";

        let categoryAxis = c.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.ticks.template.disabled = true;
        categoryAxis.renderer.axisFills.template.disabled = true;
        categoryAxis.dataFields.category = "category";
        categoryAxis.renderer.minGridDistance = 15;
        categoryAxis.renderer.inversed = true;
        categoryAxis.renderer.inside = false;
        categoryAxis.renderer.grid.template.location = 0.5;
        categoryAxis.renderer.grid.template.strokeDasharray = "1,3";

        let valueAxis = c.xAxes.push(new am4charts.ValueAxis()) as any;
        valueAxis.tooltip.disabled = true;
        valueAxis.renderer.ticks.template.disabled = true;
        valueAxis.renderer.axisFills.template.disabled = true;

        let series = c.series.push(new am4charts.ColumnSeries()) as any;
        series.numberFormatter.numberFormat = "00.00'%'";
        series.dataFields.categoryY = "category";
        series.dataFields.openValueX = "openValue";
        series.dataFields.valueX = "closeValue";
        series.tooltipText = props.tooltipText;
        series.sequencedInterpolation = true;
        series.fillOpacity = 0;
        series.strokeOpacity = 1;
        series.columns.template.height = 0.01;
        series.tooltip.pointerOrientation = "vertical";

        let openBullet = series.bullets.create(am4charts.CircleBullet);
        openBullet.locationX = 1;

        let closeBullet = series.bullets.create(am4charts.CircleBullet);

        closeBullet.fill = c.colors.getIndex(4);
        closeBullet.stroke = closeBullet.fill;

        c.cursor = new am4charts.XYCursor();
        c.cursor.behavior = "zoomY";

        c.scrollbarX = new am4core.Scrollbar();
        c.scrollbarY = new am4core.Scrollbar();
    
        return () => {
            c.dispose();
        };
      }, [props]);
    
    return (
        <div className="HorizontalDumbellPlotChart" id={props.id} style={{ width: "100%", height: "1000px" }}></div>
    );
  }
  
  export default HorizontalDumbellPlotChart;